import InjectedForm from './InjectedForm'

export default InjectedForm
